import { calc } from '@/utils'
import { SxProps } from '@mui/material'

interface LayoutWithSummaryStyles {
  mainContainer: SxProps
  container: SxProps
  contentWrapper: SxProps
  headingsWrapper: SxProps
  headingsWrapperNoSubHeading: SxProps
  heading: SxProps
  subHeading: SxProps
  summaryWrapper: SxProps
}

const SUMMARY_SIDEBAR_WIDTH = 335
const LAYOUT_GAP = 2

export const layoutWithSummaryStyles: LayoutWithSummaryStyles = {
  mainContainer: {
    pt: { lg: 0, xl: 1.5 },
    pb: 10,
  },
  container: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      lg: 'row',
    },
    gap: LAYOUT_GAP,
  },
  contentWrapper: {
    width: { xs: '100%', lg: calc(SUMMARY_SIDEBAR_WIDTH + 8 * LAYOUT_GAP) },
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  },
  headingsWrapper: { flexDirection: 'column', display: 'flex', gap: 0.5 },
  headingsWrapperNoSubHeading: { mb: { xs: 0, md: 1 } },
  heading: {
    typography: { xs: 'displayXsSemibold', md: 'displaySmSemibold' },
    color: 'text.primary',
  },
  subHeading: { typography: { xs: 'textMd', md: 'textLg' }, color: 'text.tertiary600' },
  summaryWrapper: {
    width: { xs: '100%', lg: SUMMARY_SIDEBAR_WIDTH },
    mb: { xs: 17, lg: 0 },
  },
}
